<template>
  <div>
    <div style="display: flex">
      <a-form-item-rest v-if="props.isFiliale == 1">
        <a-input
          @change="
            (res) => {
              inputChange(res, 'filiale_full_name')
            }
          "
          v-model:value="state.filiale_full_name"
          placeholder="总公司名称"
        ></a-input>
      </a-form-item-rest>
      <a-form-item-rest v-if="props.isFiliale != 1">
        <a-input
          @change="
            (res) => {
              inputChange(res, 'name_division')
            }
          "
          v-model:value="state.name_division"
          placeholder="名称区划"
        ></a-input>
      </a-form-item-rest>
      <a-form-item-rest v-if="!state.no_word">
        <a-input
          @change="
            (res) => {
              inputChange(res, 'name_word_mark')
            }
          "
          v-model:value="state.name_word_mark"
          :placeholder="props.isFiliale == 1 ? '地域或字号:第一，湖南，长沙市' : '字号'"
        ></a-input>
      </a-form-item-rest>
      <a-form-item-rest v-if="props.isFiliale != 1">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          optionLabelProp="label"
          popupClassName="principalName"
          :value="state.ondustry_representation_id"
          show-search
          placeholder="行业表述"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
          @change="handleChange"
          v-model:search-value="state.ondustry_keyword"
        >
          <a-select-option v-for="(item, index) in state.options" :key="index" :title="item.keyvalue" :value="item.id" :label="item.keyname">
            <div class="d-flex">
              <span style="width: 160px">
                {{ item.keyname }}
              </span>
              <!-- <span class="flex-1">
                <span class="top"> 置顶 </span>
              </span> -->
              <span style="width: 230px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px"> (行业：{{ item.keyvalue }}) </span>
            </div>
          </a-select-option>
        </a-select>
      </a-form-item-rest>
      <a-form-item-rest v-if="props.principalType == 1">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :value="state.organizational_form"
          @change="
            (res) => {
              selectChange(res, 'organizational_form')
            }
          "
          placeholder="请选择"
        >
          <a-select-option v-for="(item, index) in state.optionList" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-item-rest>
      <a-form-item-rest v-if="props.principalType == 2">
        <a-select
          :value="state.organizational_form"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @change="
            (res) => {
              selectChange(res, 'organizational_form')
            }
          "
          placeholder="组织形式"
        >
          <a-select-option v-for="(item, index) in state.organizationalFormList" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-item-rest>
      <a-form-item-rest v-if="props.principalType == 3">
        <a-select
          :value="state.organizational_form"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @change="
            (res) => {
              selectChange(res, 'organizational_form')
            }
          "
          placeholder="组织形式"
        >
          <a-select-option v-for="(item, index) in state.organizationalFormList_GD" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-item-rest>
      <a-form-item-rest v-if="props.principalType == 4">
        <a-select
          :value="state.organizational_form"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @change="
            (res) => {
              selectChange(res, 'organizational_form')
            }
          "
          placeholder="组织形式"
        >
          <a-select-option v-for="(item, index) in state.hehuoList" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-item-rest>
    </div>
    <div style="margin-top: 5px">
      主体名称预览：
      <span
        style="color: red; cursor: pointer"
        @click="
          (event) => {
            handleNameClick(event)
          }
        "
        >{{ state.full_name }}</span
      ><a @click="change_zihao_postion" class="ml-3x" v-if="props.principalType == 1 && state.name_division && state.name_word_mark && state.ondustry_representation && state.organizational_form"
        >地域排序换位置</a
      >
      <span v-if="props.principalType == 2 || props.principalType == 3 || props.principalType == 4" class="ml-3x">
        <a-checkbox
          v-model:checked="state.no_postfix"
          @change="
            (res) => {
              checkboxChange('no_postfix')
            }
          "
          >无后缀</a-checkbox
        >
      </span>
      <span v-if="props.principalType == 1 && props.isFiliale == 1" class="ml-3x">
        <a-checkbox
          v-model:checked="state.no_word"
          @change="
            (res) => {
              checkboxChange('no_word')
            }
          "
          >无字号</a-checkbox
        >
      </span>
      <a class="ml-3x" @click="getHangye()">获取行业</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, watch, onUnmounted } from 'vue'
const emit = defineEmits(['update:value'])
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
import { message } from 'ant-design-vue'
import { trimAll } from '@/utils/util'
let timer: any = null
const props = defineProps({
  value: {
    type: Object
  },
  principalType: {
    type: Number
  },
  company_type_id: {
    type: Number
  },
  business_type: {
    type: Number
  },
  isFiliale: {
    type: Number
  },
  is_heming: {
    type: Number,
    default: 2
  }
})
const state = reactive<any>({
  options: [],
  name_division: '',
  full_name: '',
  name_division_position: 0,
  filiale_full_name: '',
  name_word_mark: '',
  ondustry_representation: undefined,
  organizational_form: '',
  ondustry_representation_type: null,
  ondustry_representation_id: null,
  no_postfix: false,
  no_word: false,
  isFirst: true,
  // 组织形式
  optionList: ['有限公司', '有限责任公司', '集团有限公司', '分公司', '厂', '分厂', '经营部', '店', '商店', '分店', '分行', '支行', '营业部', '工作室', '分部'],
  organizationalFormList: [
    '经营部',
    '服务部',
    '商行',
    '店',
    '部',
    '工作室',
    '铺',
    '馆',
    '坊',
    '场',
    '门市部',
    '大药房',
    '药房',
    '药店',
    '厅',
    '行',
    '房',
    '社',
    '亭',
    '网咖',
    '网吧',
    '处',
    '厂',
    '咖啡厅',
    '咖啡店',
    '中心',
    '饭店',
    '饭堂',
    '吧',
    '商店',
    '商店馆',
    '浴池',
    '诊所',
    '门诊部',
    '俱乐部',
    '酒吧',
    '酒店',
    '旅店',
    '农家院',
    '农场',
    '影楼',
    '加盟店',
    '队',
    '超市',
    '家庭农场',
    '冷库',
    '餐厅',
    '苗圃',
    '医院',
    '屋',
    '广场',
    '城'
  ],
  organizationalFormList_GD: [
    '经营部',
    '部',
    '商行',
    '工作室',
    '店',
    '商店',
    '铺',
    '馆',
    '坊',
    '场',
    '门市部',
    '大药房',
    '药房',
    '药店',
    '厅',
    '行',
    '房',
    '社',
    '亭',
    '网咖',
    '网吧',
    '处',
    '厂',
    '咖啡厅',
    '咖啡店',
    '中心',
    '饭店',
    '饭堂',
    '中心',
    '吧',
    '商店馆',
    '浴池',
    '诊所',
    '门诊部',
    '馆',
    '俱乐部',
    '酒吧',
    '酒店',
    '旅店',
    '农家院',
    '农场',
    '影楼',
    '加盟店',
    '队',
    '超市',
    '家庭农场',
    '冷库',
    '餐厅',
    '苗圃',
    '医院',
    '屋',
    '广场',
    '站'
  ],

  hehuoList: ['合伙企业', '厂', '部', '店', '商行', '中心', '院', '所', '餐厅', '厅', '苗圃', '事务所', '广场', '处'], //  合伙企业
  ondustry_keyword: '',
  hangyeInterval: {
    timer: null,
    time: 5000
  }
})
onUnmounted(() => {
  clearInterval(state.hangyeInterval.timer)
})
watch(
  () => props.value,
  (val) => {
    if (val) {
      state.name_division = val.name_division || ''
      state.filiale_full_name = val.filiale_full_name || null
      state.name_word_mark = val.name_word_mark || ''
      state.ondustry_representation = val.ondustry_representation || ''
      state.ondustry_representation_type = val.ondustry_representation_type || null
      state.ondustry_representation_id = val.ondustry_representation_id || null
      if (state.ondustry_representation && val.ondustry_representation_id == 0) {
        state.ondustry_representation_id = 0 //如果选了行业，可能id真的为0，不是null
      }
      state.organizational_form = val.organizational_form || ''
      state.name_division_position = val.name_division_position || 0
      state.no_postfix = val.no_postfix == 1 ? true : false
      state.no_word = val.no_word == 1 ? true : false
      state.full_name = val.full_name || ''

      if (val.ondustry_representation) {
        if (!state.isFirst) return
        state.isFirst = false
        handleSearch(val.ondustry_representation)
      }
    }
  },
  { deep: true }
)
watch(
  () => props.principalType,
  (val) => {
    state.ondustry_representation = ''
    state.ondustry_representation_type = null
    state.ondustry_representation_id = null
    state.options = []
    if (val == 1) {
      state.organizational_form = '有限公司'
    } else {
      state.organizational_form = null
    }
    triggerChange()
  },
  { deep: true }
)
watch(
  () => props.company_type_id,
  (newVal, oldVal) => {
    //有字号并且是合伙企业，不然会重复
    if (state.name_word_mark && props.principalType == 4) {
      triggerChange()
    }
  }
)
const change_zihao_postion = () => {
  state.name_division_position += 1
  if (state.name_division_position == 3) {
    state.name_division_position = 0
  }
  triggerChange()
}
const inputChange = (value, type) => {
  console.log(value, type)
  if (type == 'name_division') {
    value.target.value = value.target.value.replace('巿', '市')
  }
  value.target.value = trimAll(value.target.value)
  state[type] = value.target.value
  triggerChange()
}
const selectChange = (value, type) => {
  if (props.principalType == 1) {
    if (value == '分公司' || state[type] == '分公司' || value == '分店' || state[type] == '分店' || state[type] == '分院') {
      state.name_division = ''
      state.ondustry_representation = ''
    }
  }
  state[type] = value
  triggerChange()
}
const checkboxChange = (type) => {
  triggerChange()
}
const triggerChange = () => {
  let full_name = ''
  if (props.isFiliale == 1) {
    if (state.no_word) {
      //分公司可以没有字号
      state.name_word_mark = ''
    }
    full_name = `${state.filiale_full_name}${state.name_word_mark}${state.organizational_form}`
  } else {
    //公司需要根据位置
    if (state.name_division_position == 0) {
      full_name = state.name_division + state.name_word_mark + state.ondustry_representation + state.organizational_form
    } else if (state.name_division_position == 1) {
      full_name = state.name_word_mark + '（' + state.name_division + '）' + state.ondustry_representation + state.organizational_form
    } else {
      full_name = state.name_word_mark + state.ondustry_representation + '（' + state.name_division + '）' + state.organizational_form
    }
    //补上括弧
    if (!state.no_postfix) {
      if (props.principalType == 2) {
        full_name = full_name + '（个体工商户）'
      } else if (props.principalType == 3) {
        full_name = full_name + '（个人独资）'
      } else if (props.principalType == 4) {
        if (props.company_type_id == 14) {
          full_name = full_name + '（有限合伙）'
        } else if (props.company_type_id == 15) {
          full_name = full_name + '（有限合伙分支机构）'
        } else if (props.company_type_id == 16) {
          full_name = full_name + '（普通合伙）'
        } else if (props.company_type_id == 17) {
          full_name = full_name + '（普通合伙分支机构）'
        } else if (props.company_type_id == 18) {
          full_name = full_name + '（特殊普通合伙）'
        } else if (props.company_type_id == 19) {
          full_name = full_name + '（特殊普通合伙分支机构）'
        }
      }
    }
  }

  emit('update:value', {
    name_division: state.name_division,
    filiale_full_name: state.filiale_full_name,
    name_word_mark: state.name_word_mark,
    ondustry_representation: state.ondustry_representation,
    organizational_form: state.organizational_form,
    ondustry_representation_type: state.ondustry_representation_type,
    ondustry_representation_id: state.ondustry_representation_id,
    name_division_position: state.name_division_position,
    no_postfix: state.no_postfix ? 1 : 2,
    no_word: state.no_word ? 1 : 2,
    full_name: full_name
  })
}
const handleSearch = (val: string) => {
  if (props.business_type != 1 || props.is_heming == 1) {
    state.options = [
      {
        id: val,
        keyname: val,
        keyvalue: val
      }
    ]
    return
  }
  clearTimeout(timer)
  if (val == '') {
    state.options = []
    return
  }
  // 必须中文
  var reg = /^[\u4E00-\u9FA5]+$/
  if (!reg.test(val)) {
    return
  }
  if (val.includes('有限公司')) {
    val = val.replace('有限公司', '')
  } else if (val.includes('有限责任公司')) {
    val = val.replace('有限责任公司', '')
  }
  state.ondustry_keyword = val
  timer = setTimeout(() => {
    if (props.principalType == 1 || props.principalType == 3 || props.principalType == 4) {
      let requestParam = {
        url: '/admin/v1/getCompanyStep?keys=' + val,
        method: 'get'
      }
      baseService(requestParam)
        .then((res) => {
          if (!res.data.some((res) => res.keyname === val)) {
            // res.data.unshift({
            //   keyname: val,
            //   id: val,
            //   keyvalue: val
            // })
          }
          state.options = res.data
        })
        .catch((res) => {
          if (res.msg) {
            message.error(res.msg)
          } else {
            message.error('操作失败')
          }
        })
    } else {
      let requestParam = {
        url: '/admin/v1/getIndividualStep?keys=' + val,
        method: 'get'
      }
      baseService(requestParam)
        .then((res) => {
          if (res.data.length == 0) {
            message.error(res.msg)
          } else {
            state.options = res.data
          }
        })
        .catch((res) => {
          if (res.msg) {
            message.error(res.msg)
          } else {
            message.error('操作失败')
          }
        })
    }
  }, 500)
}
// 复制名称
const handleNameClick = (event) => {
  var input = document.createElement('input')
  //将input的值设置为需要复制的内容
  input.value = event.target.innerHTML
  //添加input标签
  document.body.appendChild(input)
  //选中input标签
  input.select()
  //执行复制
  document.execCommand('copy')
  //成功提示信息
  message.success('复制成功，尝试双击有惊喜！')
  //移除input标签
  document.body.removeChild(input)
}
const handleChange = (val, obj) => {
  state.ondustry_representation = obj.label
  state.ondustry_representation_type = obj.title
  state.ondustry_representation_id = obj.value
  triggerChange()
}
defineExpose({
  inputChange
})
//去工商局重新获取行业
const getHangye = () => {
  if (!state.ondustry_keyword) {
    message.error('请先输入行业表述')
    return
  }
  const hide = message.loading({
    content: '查询中,请稍等',
    duration: 0,
    class: 'loading-message'
  })
  let requestParam = {
    url: '/admin/v1/getHangyeStep',
    method: 'post',
    data: { indus: state.ondustry_keyword, main_type: props.principalType }
  }
  baseServicePlus(requestParam, state.hangyeInterval)
    .then((res: any) => {
      message.success(res.msg)
      //重新搜索一下
      handleSearch(state.ondustry_keyword)
    })
    .catch((res) => {
      message.error(res.msg)
    })
    .finally(() => {
      setTimeout(hide, 0)
    })
}
</script>

<style lang="less" scoped>
.d-flex {
  justify-content: space-between;
}

.top {
  color: #1890ff;
  display: none;
  cursor: pointer;
}

.d-flex:hover {
  .top {
    display: block;
  }
}
</style>
<style lang="less">
.principalName {
  width: 500px !important;
  margin-left: -70px !important;
}
</style>
